"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTheme = {
    common: {
        fontSize: '.8rem',
        primaryTextColor: '#333',
        secondaryTextColor: '#777',
        primaryBoxBackground: '#f0f0f0',
        secondaryBoxBackground: '#ccc',
    },
    button: {
        borderRadius: 4,
        disabledBackground: '#f0f0f0',
        padding: '.3rem .8rem',
        disabledColor: '#ccc',
        outlineBorderColor: '#666',
        borderWidth: 1,
        normal: {
            borderLeft: '1px solid #f0f0f0',
            borderTop: '1px solid #f0f0f0',
            borderRight: '1px solid #ccc',
            borderBottom: '1px solid #ccc',
            normalBackground: 'linear-gradient(45deg, #f0f0f0, #ccc)',
            pressedBackground: 'linear-gradient(45deg, #ccc, #f0f0f0)',
            textColor: '#000',
        },
        primary: {
            borderLeft: '1px solid #65AE4E',
            borderTop: '1px solid #65AE4E',
            borderRight: '1px solid #46803E',
            borderBottom: '1px solid #46803E',
            normalBackground: 'linear-gradient(45deg, #65AE4E, #46803E)',
            pressedBackground: 'linear-gradient(45deg, #46803E, #65AE4E)',
            textColor: '#fff',
        },
        secondary: {
            borderLeft: '1px solid #F2E7AB',
            borderTop: '1px solid #F2E7AB',
            borderRight: '1px solid #E2AA71',
            borderBottom: '1px solid #E2AA71',
            normalBackground: 'linear-gradient(45deg, #F2E7AB, #E2AA71)',
            pressedBackground: 'linear-gradient(45deg, #E2AA71, #F2E7AB)',
            textColor: '#fff',
        },
    },
    input: {
        borderRadius: 4,
        borderWidth: 1,
        padding: '.3rem .8rem',
        normalBackground: 'linear-gradient(to bottom, #f0f0f0, #fff, #f0f0f0)',
        disabledBackground: '#f0f0f0',
        outlineBorderColor: '#666',
        disabledColor: '#ccc',
        border: '1px solid #ccc',
        textColor: '#333',
        labelFontSize: '.8rem',
    },
    header: {
        padding: '.5rem',
        bottomShadow: '0 1px 2px rgba(0,0,0,.2)',
    },
    groupBox: {
        headerPadding: '.3rem .8rem',
        contentPadding: '.8rem',
        headerBorderRadius: 4,
        contentBorderRadius: 4,
        border: '1px solid #ccc',
    },
    table: {
        table: {},
        headerCell: {
            border: '1px solid #666',
            padding: '.3rem .8rem',
            background: '#ccc',
            fontSize: '.9rem',
            color: '#333',
        },
        cell: {
            border: '1px solid #666',
            padding: '.3rem .8rem',
            background: '#f0f0f0',
            fontSize: '.8rem',
            color: '#444',
        },
    },
    dialog: {
        overlay: {
            background: 'rgba(0,0,0,.7)',
        },
        content: {
            borderRadius: 4,
            title: {
                color: '#333',
                padding: '.3rem .8rem',
                background: '#f0f0f0',
            },
            body: {
                color: '#777',
                padding: '.8rem',
                background: '#ccc',
            },
        },
    },
    paging: {
        item: {
            borderRadius: 4,
            padding: '.3rem .6rem',
            border: '1px solid #777',
            fontSize: '.7rem',
            margin: '0 .2rem',
        },
    },
};
